import type { DatasetIconProps } from "./DatasetIcon.type";

import { FaClipboard, FaRegClipboard } from "react-icons/fa";

const RecommendationIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <FaClipboard /> : <FaRegClipboard />;
};

export default RecommendationIcon;
